<!DOCTYPE html>
<html lang="en">
    <head>
        <title>HTTP Status 404 – Not Found</title>
    </head>
    <body>
        <h1>HTTP Status 404 – Not Found</h1>
    </body>
</html>